import styled, { css } from 'styled-components';

const warnStyle = css`
    background: #ff3300;
    color: #e5e5e5;
`;

const outputStyle = css`
    &,
    &:disabled {
        background: #fcfcad;
        color: #666;
        ${(props) => props.warn && warnStyle}
    }
`;

const TextInput = styled.input.attrs((props) => {
    const attrs = {
        type: 'text',
        style: {},
    };
    if (props.width) {
        attrs.style.width = props.width;
    }
    if (props.inline) {
        attrs.style.display = 'inline-block';
    }
    return attrs;
})`
    text-align: right;
    /* background: '#eee'; */
    box-sizing: border-box;

    &:disabled {
        color: rgb(170, 170, 170);
    }

    ${(props) => props.output && outputStyle}
    ${(props) => props.warn && warnStyle}
`;

export const Unit = styled.span`
    margin-left: 3px;
    font-size: 0.75rem;
    vertical-align: baseline;
`;

const NumberInput = ({
    value,
    onChange,
    onBlur,
    inputWidth,
    disabled,
    tabIndex,
    ...props
}) => {
    const handleChange = (ev) => {
        const val = ev.target.value;
        onChange(val.replace(/^(-)|[^0-9.,]+/g, '$1'));
    };

    const handleBlur = (ev) => {
        const val = ev.target.value;
        onBlur(val);
    };

    return (
        <TextInput
            onChange={handleChange}
            value={value}
            width={inputWidth}
            disabled={disabled}
            onBlur={onBlur ? handleBlur : null}
            tabIndex={tabIndex}
            {...props}
        />
    );
};

export default NumberInput;
